import { initial_modal } from "./reducer";
import { ModalState } from "./types";

export enum ModalAction {
  CLOSE_MODAL = 'CLOSE_MODAL',
  UPDATE_MODAL = 'UPDATE_MODAL'
}

export const closeModal = () => ({
  type: ModalAction.CLOSE_MODAL,
  data: initial_modal
})

export const openModal = (data: ModalState) => ({
  type: ModalAction.UPDATE_MODAL,
  data
})
